import { CustomForm, CustomFormArray, CustomFormGroup } from "@tilby/tilby-ui-lib/components/tilby-magic-form";
import { ProvValidator } from "@tilby/tilby-ui-lib/utilities";
import { ItemsForm } from "src/app/features/items/models/items-form.model";
import { Items, ItemsBarcodes, ItemsCombinationsBarcodes, ItemsPrinters } from "tilby-models";

export type ItemsBarcodeQty = (ItemsBarcodes | ItemsCombinationsBarcodes) & {
    qty: number
}

export type ItemGeneralFormGroups = {
    detailsForm: CustomFormGroup<ItemsForm>,
    pricesForm: CustomFormGroup<ItemsForm>,
    costsForm: CustomFormGroup<ItemGeneralCostFormGroupFields>,
    printersForm: CustomFormGroup<ItemsFormWithCustomPrinters>;
}
    
export type ItemGeneralCostFormGroupFields = Partial<CustomForm<ItemCostsFields>>;
export type ItemCostsFields = Items & ItemsCostsFe;

export interface ItemsCostsFe {
    itemMargin?: string;
    itemMarkup?: string;
}

export type ItemsFormWithCustomPrinters = Omit<ItemsForm, 'printers'> & {
    printers?: CustomFormArray<CustomFormGroup<ItemsPrintersFormArray>>;
};

export type ItemsPrintersFormArray = Partial<CustomForm<ItemPrintersFields>>;
export type ItemPrintersFields = ItemsPrinters & ItemsPrintersFe;

export interface ItemsPrintersFe {
    _enabled: boolean;
    _categoryEnabled: boolean;
}
export interface ItemGeneralValidators extends ProvValidator {
    nameMaxLength: number;
    seasonMaxLength: number;
    brandMaxLength: number;
    indexMin: number;
    pricesMin: number;
    costNoVatMin: number;
    skuMaxLength: number;
    codeMaxLength: number;
    weightMin: number;
    codePienissimoMaxLength: number;
}

export const GENERAL_FE_KEYS = [
    'itemMargin',
    'itemMarkup'
]